export default __webpack_public_path__ + "static/media/portfolio-nexx-2.46d90a87.jpg";